import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Observable, Subject, from } from 'rxjs';
import { Platform } from '@ionic/angular';
import firebase from 'firebase/app';
import { filter, first, map, take } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';
import {environment} from "../../../environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";

@Injectable()
export class FirebaseAuthService {

  currentUser: firebase.User;
  userProviderAdditionalInfo: any;
  redirectResult: Subject<any> = new Subject<any>();

  constructor(
    public angularFireAuth: AngularFireAuth,
    private angularFirestore: AngularFirestore,
    public platform: Platform,
    public httpClient: HttpClient
  ) {
    this.angularFireAuth.onAuthStateChanged((user) => {
      if (user) {
        // User is signed in.
        this.currentUser = user;
      } else {
        // No user is signed in.
        this.currentUser = null;
      }
    });
  }

  setProviderAdditionalInfo(additionalInfo: any) {
    this.userProviderAdditionalInfo = {...additionalInfo};
  }

  signOut(): Observable<any> {
    return from(this.angularFireAuth.signOut());
  }

  signInWithEmail(email: string, password: string): Promise<firebase.auth.UserCredential> {
    return this.angularFireAuth.signInWithEmailAndPassword(email, password);
  }

  sendPasswordResetEmail(email: string) {
    return this.angularFireAuth.sendPasswordResetEmail(email);
  }

  signUpWithEmail(email: string, password: string) {
    return this.angularFireAuth.createUserWithEmailAndPassword(email, password);
  }

  signUpWithEmailViaFunctions(email: string, password: string, userData: any, institution: string) {
    const body = {
      email: email,
      password: password,
      userData: userData,
      institution: institution,
    };
    return this.httpClient.post(environment.functionsUrl + 'signUpUserWithEmail', body);
  }

  sendVerificationMail() {
    return this.angularFireAuth.currentUser.then((currentUser) => {
      currentUser.sendEmailVerification().then((verificationSent) => {
        //this.router.navigateByUrl('/auth/verify-email');
      }).catch((err) => {
        console.error('error in sending verification mail', err);
        throw new Error(err);
      });
    });
  }

  setUserData(user: any, userData: any) {
    userData.uid = user.uid;
    userData.email = user.email;
    userData.displayName = user.displayName || "";
    userData.photoURL = user.photoURL || "";
    userData.emailVerified = user.emailVerified;

    this.angularFirestore.collection('users').doc(user.uid).set(userData).then((userCreated) => {

    }).catch((err) => {
      console.error('Could not create user data.', err);
      throw new Error(err);
    });
  }

  isAuthenticated() {
    return this.angularFireAuth.authState;
    //return this.angularFireAuth.authState.pipe(first()).toPromise();
  }

  getFireAuth() {
    return this.angularFireAuth;
  }

  changePassword(password: string) {
    return this.currentUser.updatePassword(password);
  }

  getIdToken() {
    return this.angularFireAuth.idTokenResult;
  }

  newUserAction(token, user, fullUserData) {
    delete fullUserData.email;
    delete fullUserData.password;
    delete fullUserData.confirmPassword;
    fullUserData.uid = user.uid;
    fullUserData.email = user.email;
    fullUserData.displayName = user.displayName || '';
    fullUserData.photoURL = user.photoURL || '';
    fullUserData.emailVerified = user.emailVerified;

    const body = {
      user: fullUserData,
    };

    const headers = new HttpHeaders().set('authorization','Bearer ' + token);
    const httpOptions = {
      headers: headers
    };
    return this.httpClient.put(environment.functionsUrl + 'user-newUserAction', body, httpOptions);
  }
}
